<style lang="less" >
*{
  font-family: PingFangSC-Regular, PingFang SC !important;
}

</style>

<template>
  <div id="app">   
    <router-view ></router-view>
  </div>
</template>

<script>
export default {
}
</script>

